import { checkFieldExistence, clearFieldErrorArray } from '../../../AppConfig/actions';
import { change, Field, formValueSelector, getFormMeta, reduxForm } from 'redux-form';
import {
  getMasterData,
  getPayerInfoById,
  SavePayerInfo,
} from '../../actions';
import {
  isValidApartmentWithSpace,
  isValidName,
  isValidNameWithSpace,
  normalizeFax,
  normalizeMobile,
  normalizeZipCode,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
  isInteger,
} from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import { AMEGO, AMEGOFL, ARROWS, base64Encode, CONVERGENCY, displayCustomError, STAGINGQA, VIP, alertConfirmation } from '../../../../../src/actions/utilAction';
import { MODULE } from './../../constants/ApiConstants';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import validate from '../validate';
import history from '../../../../history';
//import Tooltip from '../../../../components/Tooltip';

const validateOtherTaxonomy = (value) => !(value ? value.trim() : value) ? 'Please enter taxonomy code' : undefined;

const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

// const styles = {
//   font: {
//     fontStyle: 'ITALIC',
//   },
// };

// const validateJurisdictionEVV = (jurisdictionId) => {
//   if (!jurisdictionId) {
//     return 'Please select jurisdiction.';
//   } else if (!Number.isInteger(jurisdictionId)) {
//     return 'Please select an option.';
//   }  
// };
// const validatePayerEVV = (payerEVVId) => {
//   if (!payerEVVId) {
//     return 'Please select payer.';
//   } else if (!Number.isInteger(payerEVVId)) {
//     return 'Please select an option.';
//   }  
// };
// const validatePlanEVV = (planId) => {
//   if (!planId) {
//     return 'Please select plan.';
//   } else if (!Number.isInteger(planId)) {
//     return 'Please select an option.';
//   }  
// };
// const validateProgramEVV = (programId) => {
//   if (!programId) {
//     return 'Please select program.';
//   } else if (!Number.isInteger(programId)) {
//     return 'Please select an option.';
//   }  
// };
// const validateDeliverySystemEVV = (deliverySystemId) => {
//   if (!deliverySystemId) {
//     return 'Please select delivery system.';
//   } else if (!Number.isInteger(deliverySystemId)) {
//     return 'Please select an option.';
//   }  
// };

const validateProviderMedicaId = (providerMedicaidId) => {
  if (!providerMedicaidId || providerMedicaidId.trim() === '') {
    return 'Please enter NPI number';
  } else if (providerMedicaidId && providerMedicaidId.length < 8) {
    return 'Please enter valid NPI number';
  }
};



class PayerInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePayerId: null,
      saveAndContinueFlag: false,
      filteredStatesByCountry: [],
      masterState: [],
      masterCountry: [],
      masterInsuranceTypes: [],
      latitude: 0.0,
      longitude: 0.0,
      form1500PrintFormat: [{ id: 1, value: 'Normal' }, { id: 2, value: 'Pre-Printed' }],
      Taxonomylist: [{ id: '106S00000X', value: '106S00000X - BT' }, { id: '106E00000X', value: '106E00000X - BCaBA'  },{ id: '103K00000X', value: '103K00000X - BCBA'  },{ id: 'Other', value: 'Other' }],
      displayOtherTaxonomy: false,
      //isEvvPayer: false,
    };

    this.checkPayerOptions = this.checkPayerOptions.bind(this);
    this.checkBox32Options = this.checkBox32Options.bind(this);
  }


  componentWillMount() {
    this.props.getMasterData();
    if (this.props.payerId) {
      this.props.getPayerInfoById(this.props.payerId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.master_data && nextProps.master_data !== this.props.master_data) {
      this.setState({
        masterCountry: nextProps.master_data.masterCountry,
        masterState: nextProps.master_data.masterState,
      }, () => {
        this.getFilteredPrimaryStatesList(this.props.initialValues.countryID);
      });
    }
    if (nextProps.initialValues && nextProps.initialValues.countryID && nextProps.initialValues.countryID !== this.props.initialValues.countryID) {
      this.getFilteredPrimaryStatesList(nextProps.initialValues.countryID);
    }

    // if (nextProps.initialValues && nextProps.initialValues.isEVVPayer) {    
    //   this.setState({ isEvvPayer: true });      
    // }
    // if (nextProps.payerId && this.state.saveAndContinueFlag === true) {
    //   this.props.handlePayerTabChange('1');
    // }

    if (nextProps.payerId !== this.props.payerId) {
      if (nextProps.payerId && this.state.saveAndContinueFlag) {
        this.setState({ saveAndContinueFlag: false });
        this.props.handlePayerTabChange('1');
      }
    }

    if (nextProps.save_payer_data && nextProps.save_payer_data !== this.props.save_payer_data) {
      let payerId = nextProps.save_payer_data.data && nextProps.save_payer_data.data.id;
      if (!this.props.payerId && payerId) {
        let payerIdEnc = base64Encode(`${payerId}`);
        history.push(`/payer/${payerIdEnc}`);
      } else if (this.state.saveAndContinueFlag) {
        this.setState({ saveAndContinueFlag: false });
        this.props.handlePayerTabChange('1');
      }
    }

    if (nextProps.activePayerInfo && nextProps.activePayerInfo !== this.props.activePayerInfo) {
      if (nextProps.activePayerInfo.data) {
        let data = nextProps.activePayerInfo.data;
        this.setState({
          address: nextProps.activePayerInfo.data.address,
          latitude: nextProps.activePayerInfo.data.latitude,
          longitude: nextProps.activePayerInfo.longitude,
          displayOtherTaxonomy: ((data.taxonomyCode !== '' && data.taxonomyCode !== undefined && data.taxonomyCode !== '106S00000X' && data.taxonomyCode !== '106E00000X' && data.taxonomyCode !== '103K00000X') ? true : false),
        }, () => { });
      }
    }

    if (this.props.payerName) {      
      this.props.setPayerName(this.props.payerName);
    }

  }

  _handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        userAvatar: reader.result,
      });
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  }


  handleRemoveImage = (e, type) => {
    e.preventDefault();
    this.setState({ userAvatar: '' });
  };

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  checkPayerOptions = (e, name) => {
    if (name === 'dayClubByProviderOnOneClaim' && e.target.checked) {      
      this.props.dispatch(change('PayerInfo', 'dayClubByProvider', false));
    } else if ((name === 'dayClubByProvider') && e.target.checked) {
      this.props.dispatch(change('PayerInfo', 'dayClubByProviderOnOneClaim', false));
    }
  }

  checkBox32Options = (e, name) => {
    if (name === 'leaveBox32Blank' && e.target.checked) {      
      this.props.dispatch(change('PayerInfo', 'leaveBox32BlankAlways', false));
    } else if ((name === 'leaveBox32BlankAlways') && e.target.checked) {
      this.props.dispatch(change('PayerInfo', 'leaveBox32Blank', false));
    }
  }

  // checkEvvPayerOptions = (e, name) => {
  //   if (name === 'isEVVPayer' && e.target.checked)       
  //     this.setState({ isEvvPayer: true });    
  //   else 
  //     this.setState({ isEvvPayer: false });     
  // }

  handleSaveContinue = (formData) => {
    this.onSubmit(formData);
    this.setState({ saveAndContinueFlag: true });
  };

  handleSaveAndContinueChanges = (event) => {
    event.preventDefault();
    const{handleSubmit} = this.props;
    alertConfirmation('You are making changes to the Payer. Are you sure you want to save the changes?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: handleSubmit(this.handleSaveContinue),
      },
    })
  }

  handleSave = (formData) => {
    this.onSubmit(formData);
  }

  handleSaveChanges = (event) => {
    event.preventDefault();
    const{handleSubmit} = this.props;
    alertConfirmation('You are making changes to the Payer. Are you sure you want to save the changes?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: handleSubmit(this.handleSave),
      },
    })
  }


  onSubmit = (formData) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    if(this.props.fieldError_Payername && this.props.fieldError_Payername.length){
      return null;
    }
    formData.id = this.props.payerId;
    formData['name'] = formData.name ? formData.name.trim() : null;    
    formData['isActive'] = formData.isActive ? true : false;
    formData['address'] = formData.address ? formData.address.trim() : null;    
    formData['city'] = formData.city ? formData.city.trim() : null;    
    formData['additionalClaimInfo'] = formData.additionalClaimInfo ? formData.additionalClaimInfo.trim() : null;        
    formData['billingAddress'] = formData.billingAddress ? formData.billingAddress.trim() : null;    
    formData['billingCity'] = formData.billingCity ? formData.billingCity.trim() : null;        
    formData['taxonomyCode'] = this.state.displayOtherTaxonomy ? (formData.taxonomyCode ? formData.taxonomyCode.trim() : '') : (formData.taxonomyCodeIds || '');      
    formData['billingProviderInfo'] = formData.billingProviderInfo ? formData.billingProviderInfo.trim() : null;     
    formData['latitude'] = this.state.latitude;
    formData['longitude'] = this.state.longitude;

    // console.log('formdataaa.............', JSON.stringify(formData));
    this.props.SavePayerInfo(formData);
  };

  handleNewRequest = (input, selectedRecord) => {
    if (input.name === ('countryID')) {
      this.getFilteredPrimaryStatesList(selectedRecord.value);
    } else if (input.name === 'taxonomyCodeIds') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 'Other') {          
          this.props.dispatch(change('PayerInfo', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: true });
        } else {          
          this.props.dispatch(change('PayerInfo', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: false });
        }
      } else {
        
        this.setState({ displayOtherTaxonomy: false });
      }
    }
    input.onChange(selectedRecord.value);
  };

  getFilteredPrimaryStatesList = (countryID) => {
    if (this.state.masterState) {
      let allStates = this.state.masterState;
      let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
      this.setState({ filteredStatesByCountry: filteredStates });
    }
  };

  render() {
    const { handleSubmit } = this.props;
    const hasButtonError = this.props.id && ((this.props.fieldError_Payername && this.props.fieldError_Payername.length === 0) && (this.props.fieldError_Email && this.props.fieldError_Email.length === 0))
    return (
      <div>
        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="insuranceTypeId"
                label="Insurance Type"
                options={this.props.masterInsuranceType ? this.props.masterInsuranceType : []}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="name"
                type="text"
                label="Payer Name"
                maxLength="50"
                onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Payer name')}
                customError={displayCustomError('NAME', this.props.fieldError_Payername)}
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="tplCode"
                type="text"
                label="TPL Code"
                normalize={isValidName}
                maxLength="20"
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Field
                name="carrierPayerID"
                type="text"
                maxLength="10"
                normalize={isValidName}
                label="Carrier Payer Id"
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="email"
                type="text"
                label="Email"
                maxLength="60"
                onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Email')}
                customError={displayCustomError('EMAIL', this.props.fieldError_Email)}
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="phone"
                type="text"
                label="Phone"
                maxLength="14"
                normalize={normalizeMobile}
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Field
                name="fax"
                normalize={normalizeFax}
                type="text"
                maxLength='14'
                label="Fax"
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-8 require">
              <Field
                name="address"
                type="text"
                maxLength="55"
                label="Address"
                // normalize = {isValidNameWithSpace}
                fullWidth={true}
                component={renderTextField}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="apartmentNumber"
                type="text"
                maxLength='15'
                label="Apt/Unit"
                normalize={isValidApartmentWithSpace}
                component={renderTextField} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="countryID"
                label="Country"
                ref="countryID"
                // value={this.state.country}
                options={this.state.masterCountry}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="city"
                type="text"
                label="City"
                maxLength='50'
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="stateID"
                label="State"
                disabled={!this.props.countryID}
                options={this.state.filteredStatesByCountry}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 require">
              <Field
                name="zip"
                type="text"
                //normalize={normalizeZipCode}
                maxLength={10}
                label="Zip Code"
                component={renderTextField} />
            </div>
            <div className="col-sm-4">
              <Field
                name="box17AQualifier"
                type="text"
                normalize={isValidNameWithSpace}
                maxLength={2}
                label="Box 17A Qualifier"
                component={renderTextField} />
            </div>
            <div className="col-sm-4"></div>
            {/* <div className="col-sm-4">
              <Field
                  name="taxonomyCode"
                  type="text"
                  maxLength='100'
                  label="Billing Provider Taxonomy Code"                    
                  component={renderTextField} />
            </div>
            <div className="col-sm-4">
                  <Field
                    name="billingTaxId"
                    label="Billing Tax ID #(Professional)"
                    maxLength='9'
                    component={renderTextField}
                    normalize={isInteger}
                  />
            </div> */}
          </div>
          <div className="row">
            <div className="col-sm-4 mt-40">
              <Field
                name="dayClubByProvider"
                label="Day Club By Provider"
                component={renderCheckBox}
                style={stylescss.checkbox}
                onChange={(e) => this.checkPayerOptions(e, 'dayClubByProvider')}
              />
            </div>  
            <div className="col-sm-4 mt-40">
              <Field
                name="isEDIPayer"
                label="EDI Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isPractitionerIsRenderingProvider"
                label="Practitioner Is Rendering Provider"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>            
          </div>
          <div className="row">
            <div className='col-sm-4 require mt-40'>
              <Field
                name="form1500PrintFormat"
                label="Print Formats"
                options={this.state.form1500PrintFormat}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isTricare"
                label="Tricare"
                component={renderCheckBox}
                style={stylescss.checkbox}
                //onChange={(e) => this.checkPayerOptions(e, 'isTricare')}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="addCountyCodeInBox19"
                label="Add County Code in Box 19 (Form 1500)"
                component={renderCheckBox}
                style={stylescss.checkbox}
                //onChange={(e) => this.checkPayerOptions(e, 'isAddCountyCodeInBox19')}
              />
            </div>            
          </div>
          <div className="row">
            <div className="col-sm-4 mt-40">
              <Field
                name="isActive"
                label="Active"
                disabled={true}
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>            
            <div className="col-sm-4 mt-40">
              <Field
                name="dayClubByProviderOnOneClaim"
                label="Day Club by provider w/ same DOS on one claim"
                component={renderCheckBox}
                style={stylescss.checkbox}
                onChange={(e) => this.checkPayerOptions(e, 'dayClubByProviderOnOneClaim')}
              />                
            </div> 
            {this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === AMEGOFL || this.props.agencyName.toUpperCase() === VIP ?      
            <div className="col-sm-4 mt-40">
              <Field
                name="isDPHPayer"
                label="DPH Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}                
              />     
              </div>: null}       
            {this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === 'ABCSPECTRUM' ?          
            <div className="col-sm-4 mt-40">
              <Field
                name="isLACarePayer"
                label="LA Care Payer"
                component={renderCheckBox}
                style={stylescss.checkbox}                
              />     
              </div>: null}  
             {this.props.agencyName.toUpperCase() === ARROWS ?          
              <div className="col-sm-4 mt-40">
                <Field
                  name="isMedicaidIdOverridingRenderingNPI"
                  label="Add Medicaid ID on Claim (Box 24J)"
                  component={renderCheckBox}
                  style={stylescss.checkbox}                
                />     
                </div>: null} 
                <div className="col-sm-4 mt-40">
                  <Field
                    name="leaveBox32Blank"
                    label="Box 32 should be blank if address and NPI are the same as Box 33"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                    onChange={(e) => this.checkBox32Options(e, 'leaveBox32Blank')}
                  />
                </div>                 
                <div className="col-sm-4 mt-40">
                  <Field
                    name="leaveBox32BlankAlways"
                    label="Only display address in Box 32 if location code is 11"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                    onChange={(e) => this.checkBox32Options(e, 'leaveBox32BlankAlways')}
                  />
                </div>
                <div className="col-sm-4 mt-40">
                  <Field
                    name="sendOrderingProviderNPIInEDIClaim"
                    label="Send ordering provider NPI in EDI claim (use same # as referring)"
                    component={renderCheckBox}
                    style={stylescss.checkbox}                    
                  />
                </div>
              {/* <div className="col-sm-4 mt-40 payer">
                <Field
                  name="isEVVPayer"
                  label="EVV Payer"
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                  onChange={(e) => this.checkEvvPayerOptions(e, 'isEVVPayer')}
                />   
                <span><Tooltip Description='Only applicable for Florida Medicaid. Please contact support and request an EVV training prior to checking this box' /></span>             
              </div>             */}
          </div>
          {/* { this.state.isEvvPayer ?
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="jurisdictionId"
                label="Jurisdiction"                
                options={this.props.masterJurisdictionEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.state.isEvvPayer ? validateJurisdictionEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="payerEVVId"
                label="Payer"                
                options={this.props.masterPayerEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.state.isEvvPayer ? validatePayerEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="planId"
                label="Plan"                
                options={this.props.masterPlanEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.state.isEvvPayer ? validatePlanEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>           
          </div>
          : null} 
          {this.state.isEvvPayer ?
          <div className="row">
            <div className="col-sm-4 require mt-35">
              <Field
                name="programId"
                label="Program"                
                options={this.props.masterProgramEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.state.isEvvPayer ? validateProgramEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require mt-35">
              <Field
                name="deliverySystemId"
                label="Delivery System"                
                options={this.props.masterDeliverySystemEVV}
                handleNewRequest={this.handleNewRequest}
                validate={this.state.isEvvPayer ? validateDeliverySystemEVV : null}
                component={renderAutoCompleteSingleSelect} />
            </div>
            <div className="col-sm-4 require">
              <Field
                name="providerMedicaidId"
                type="text"
                maxLength="10"
                normalize={isValidNameWithSpace}
                label="Provider Medicaid Id"
                validate={this.state.isEvvPayer ? validateProviderMedicaId : null}
                component={renderTextField} />
            </div>
          </div>
          : null}*/}
          <div className="row">
              <div className="col-sm-12 mt-40">
                <Field
                    name="additionalClaimInfo"
                    type="text"
                    label="Additional Claim Info (Box 19 Form 1500)"
                    maxLength="250"
                    component={renderTextField} />
              </div>
          </div>        
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Billing Provider Section</h3>
                <i className="flaticon flaticon-medical-4"></i>
              </div>
            </div>
            <div className="col-sm-12">
              <Field
                name="billingAddress"
                type="text"
                maxLength="55"
                label="Address"
                // normalize = {isValidNameWithSpace}
                fullWidth={true}
                component={renderTextField}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="billingApartmentNumber"
                type="text"
                maxLength='15'
                label="Apt/Unit"
                normalize={isValidApartmentWithSpace}
                component={renderTextField} />
            </div>                  
            <div className="col-sm-4 mt-35">
              <Field
                name="billingCountryID"
                label="Country"
                handleNewRequest={this.handleNewRequest}
                options={this.state.masterCountry}
                component={renderAutoCompleteSingleSelect}/>
            </div>
            <div className="col-sm-4">
              <Field
                name="billingCity"
                type="text"
                label="City"
                maxLength='50'
                normalize={isValidNameWithSpace}
                component={renderTextField} />
            </div>
            <div className="col-sm-4 mt-35">
              <Field
                name="billingStateID"
                label="State"
                handleNewRequest={this.handleNewRequest}
                options={this.state.filteredStatesByCountry}
                component={renderAutoCompleteSingleSelect} />
            </div>                  
            <div className="col-sm-4">
              <Field
                name="billingZip"
                type="text"
                //normalize={normalizeZipCode}
                maxLength={10}
                label="Zip Code"
                component={renderTextField} />
            </div>
            <div className="col-sm-6 mt-35">
                <Field
                  name="taxonomyCodeIds"
                  label="Taxonomy Code"
                  handleNewRequest={this.handleNewRequest}
                  options={this.state.Taxonomylist}
                  component={renderAutoCompleteSingleSelect} />
            </div>
            {this.state.displayOtherTaxonomy && 
            <div className="col-sm-4 require">
              <Field
                  name="taxonomyCode"
                  type="text"
                  maxLength='100'
                  label="Billing Provider Taxonomy Code"                    
                  component={renderTextField}                  
                  validate={this.state.displayOtherTaxonomy ? [validateOtherTaxonomy] : null}
                  />
            </div>}
            <div className="col-sm-4">
                  <Field
                    name="billingTaxId"
                    label="Billing Tax ID #(Professional)"
                    maxLength='9'
                    component={renderTextField}
                    normalize={isInteger}
                  />
            </div>   
            <div className="col-sm-8">
              <Field
                name="billingProviderInfo"
                label="Billing Provider Name"
                type="text"
                maxLength="250"
                // normalize ={isValidNameWithSpace}
                component={renderTextField}
              />
            </div>
          </div>
          {/* {this.props.agencyName.toUpperCase().startsWith(EBS) ?      
          <div className="row">
            <div className="col-sm-4 mt-40">
              <Field
                name="isPractitionerSignRequired"
                label="Practitioner sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isGuardianSignRequired"
                label="Guardian sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                name="isRenderingProviderSignRequired"
                label="Supervising clinician sign required to complete SOAP"
                component={renderCheckBox}
                style={stylescss.checkbox}
              />
            </div>
          </div>
          : null} */}
          <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              <RaisedButton type="button" primary={true} onClick={hasButtonError? this.handleSaveChanges : handleSubmit(this.handleSave)} label="Save"></RaisedButton>
              <RaisedButton className="ml_15" onClick={hasButtonError ? this.handleSaveAndContinueChanges : handleSubmit(this.handleSaveContinue)} primary={true} label="Save & Continue" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const selector = formValueSelector('PayerInfo');

const mapStateToProps = (state, ownProps) => {
 let payerName = null;
  // console.log('state.payer.activePayerInfo..............',state.payer.activePayerInfo)
  let initialData = {};
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';

  if (ownProps.payerId && state.payer.get_payer_data_by_id && state.payer.get_payer_data_by_id.data) {
    payerName = state.payer.get_payer_data_by_id.data.name;

    initialData = state.payer.get_payer_data_by_id.data;
    if(state.payer.get_payer_data_by_id.data.taxonomyCode !== '' && state.payer.get_payer_data_by_id.data.taxonomyCode !== undefined && state.payer.get_payer_data_by_id.data.taxonomyCode !== '106S00000X' && state.payer.get_payer_data_by_id.data.taxonomyCode !== '106E00000X' && state.payer.get_payer_data_by_id.data.taxonomyCode !== '103K00000X') 
    {
      initialData.taxonomyCode = state.payer.get_payer_data_by_id.data.taxonomyCode;
      initialData.taxonomyCodeIds = 'Other';
    }
    else {      
      initialData.taxonomyCodeIds = state.payer.get_payer_data_by_id.data.taxonomyCode;
    } 
  } else {
    initialData['isActive'] = true;
    initialData['isEDIPayer'] = true;
    initialData['form1500PrintFormat'] = 1;
    initialData['countryID'] = state.payer.master_data && state.payer.master_data.masterCountry ? state.payer.master_data.masterCountry.filter((obj) => obj.countryName === countryName)[0].id : [];
  }
  let fieldError_Payername = null;
  let fieldError_Email = null;

  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_Payername = state.appConfig.fieldError.filter((obj, i) => obj.data === 'NAME');
    fieldError_Email = state.appConfig.fieldError.filter((obj, i) => obj.data === 'EMAIL');
  }

  let masterJurisdictionEVV = [], masterPayerEVV = [], masterPlanEVV = [], masterProgramEVV = [], masterDeliverySystemEVV = [];

  if(state.payer.master_data && state.payer.master_data.masterEVVDetails)
  {
    masterJurisdictionEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'JURISDICTION' && obj.rendSvsSupported === 'Yes') : [];
    masterPayerEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PAYER' && obj.rendSvsSupported === 'Yes') : [];
    masterPlanEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PLAN' && obj.rendSvsSupported === 'Yes') : [];
    masterProgramEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'PROGRAM') : [];
    masterDeliverySystemEVV = state.payer.master_data && state.payer.master_data.masterEVVDetails ? state.payer.master_data.masterEVVDetails.filter((obj) => obj.category === 'DELIVERYSYSTEM' && obj.rendSvsSupported === 'Yes') : [];
  } 

  return {
    save_payer_data: state.payer.save_payer_data,
    masterInsuranceType: state.payer.master_data.masterInsuranceType || [],
    formMeta: getFormMeta('PayerInfoForm')(state),
    initialValues: initialData,
    activePayerInfo: state.payer.get_payer_data_by_id,
    payerAdded: state.payer.payerAdded,
    master_data: state.payer.master_data,
    countryID: selector(state, 'countryID'),
    fieldError_Payername: fieldError_Payername,
    fieldError_Email: fieldError_Email,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    masterJurisdictionEVV: masterJurisdictionEVV,
    masterPayerEVV: masterPayerEVV,
    masterPlanEVV: masterPlanEVV,
    masterProgramEVV: masterProgramEVV,
    masterDeliverySystemEVV: masterDeliverySystemEVV,
    id: selector(state, 'id'),
    payerName: payerName,
  };
};

PayerInfo = reduxForm({
  form: 'PayerInfo',
  validate,
  enableReinitialize: true,
})(PayerInfo);


export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getMasterData, SavePayerInfo, getPayerInfoById })(PayerInfo);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/information_old.js